"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Org/InfoTab/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);


var _Org = require('web/components/Settings/Org');
var _Form = require('./Form'); var _Form2 = _interopRequireDefault(_Form);
var _PatientAppSection = require('./PatientAppSection'); var _PatientAppSection2 = _interopRequireDefault(_PatientAppSection);
var _StopLineSection = require('./StopLineSection'); var _StopLineSection2 = _interopRequireDefault(_StopLineSection);
var _TranslationSection = require('./TranslationSection'); var _TranslationSection2 = _interopRequireDefault(_TranslationSection);











const OrgInfoTab = ({
  orgKey, isEditable, securityHome = 'org', onOpenAccountSettings = null,
}) => {
  const onSubmit = _react.useCallback.call(void 0, 
    (d) =>
      _actions2.default.updateOrgInfo({
        OrgKey: orgKey,
        Name: d.name,
        Address: d.address,
        Email: d.email,
        Phone: d.phone,
      }),
    [orgKey],
  )

  const onSubmitMFA = _react.useCallback.call(void 0, 
    (required) =>
      _actions2.default.updateOrgMFASettings({
        OrgKey: orgKey,
        Required: required,
      }),
    [orgKey],
  )

  return (
    _react2.default.createElement(_Org.TabWrapper, { classNameSuffix: "info", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
      , _react2.default.createElement(_Form2.default, {
        orgKey: orgKey,
        onSubmit: onSubmit,
        onSubmitMFA: onSubmitMFA,
        isEditable: isEditable,
        securityHome: securityHome,
        onOpenAccountSettings: onOpenAccountSettings, __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
      )
      ,  isEditable && _react2.default.createElement(_PatientAppSection2.default, { orgKey: orgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}} ) 
      ,  isEditable && _react2.default.createElement(_StopLineSection2.default, { orgKey: orgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}} ) 
      ,  isEditable && _react2.default.createElement(_TranslationSection2.default, { orgKey: orgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}} ) 
    )
  )
}

exports. default = OrgInfoTab
